import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './_helpers/auth.guard';
import { LoginGuard } from './_helpers/login.guard';
import { RoomServiceGuard } from './_helpers/room-service.guard';
import { EmergencyGuard } from './_helpers/emergency.guard';

const loginModule = () => import('./login/login.component').then((x) => x.LoginComponent)
const restModule = () => import('./reset-password/reset-password.component').then((x) => x.ResetPasswordComponent)
const dashboardModule = () => import('./dashboard/dashboard.component').then((x) => x.DashboardComponent)
const collectiveDashboardModule = () => import('./collective-dashboard/collective-dashboard.component').then((x) => x.CollectiveDashboardComponent)
// const LaundryDashbaordModule = () => import('./laundry-dashboard/laundry-dashboard.component').then((x) => x.LaundryDashboardComponent)
const studentModule = () => import('./student/student.component').then((x) => x.StudentComponent)
const userModule = () => import('./user/user.module').then((x) => x.UserModule)
const customerModule = () => import('./customer/customer.module').then((x) => x.CustomerModule)
const RoomServiceModule = () => import('./RoomService/room-service.module').then((x) => x.RoomServiceModule)
const LaundryModule = () => import('./Laundry/laundry.module').then((x) => x.LaundryModule)
const restaurantModule = () => import('./Restaurant/restaurant.module').then((x) => x.RestaurantModule)
const uploadLaundryBanner = () => import('./Laundry/upload-laundry-banner/upload-laundry-banner.moule').then((x) => x.UploadLaundryBannerModule)
const uploadRestaurantsBanner = () => import('./Restaurant/upload-restaurant-banner/upload-restaurant-banner.module').then((x) => x.RestaurantBannerModule)
const MenuManagementModule = () => import('./Restaurant/menu-management/menu-management.module').then((x) => x.MenuManagementModule)
const LaundryReportGeneration = () => import('./Laundry/laundry-report/laundry-report.module').then((x) => x.LaundryReportModule)
const RoomReportGeneration = () => import('./RoomService/rommservice-report/rommservice-report.module').then((x) => x.RommserviceReportModule)
const ResidentialReportModule = () => import('./ResidentialService/residential-report/residential-report.module').then((x) => x.ResidentialReportModule)
const restaurantReportGeneration = () => import('./Restaurant/food-report-generation/food-report-generation.module').then((x) => x.FoodReportGenerationModule)
const RestaurantSettlementModule = () => import('./Restaurant/restaurant-settlement/restaurant-settlement.module').then((x) => x.RestaurantSettlementModule)
const LaundrySettlementModule = () => import('./Laundry/laundry-settlement/laundry-settlement.module').then((x) => x.LaundrySettlementModule)
const ClubSettlementModule = () => import('./club/club-settlement/club-settlement.module').then((x) => x.ClubSettlementModule)

// delivery
const DeliveryModule = () => import('./Laundry/Delivery/delivery/deliver.module').then((x) => x.DeliveryModule)
const CancelModule = () => import('./Laundry/Delivery/cancelled/cancelled.module').then((x) => x.CancelledModule)
const rejectModule = () => import('./Laundry/Delivery/rejected/rejected.module').then((x) => x.RejectModule)
const AcceptedModule = () => import('./Laundry/Delivery/accepted/accepted.module').then((x) => x.AcceptedModule)
const PickupModule = () => import('./Laundry/Delivery/process-pickup/process-pickup.module').then((x) => x.ProcessPickupModule)
const NewOrderModule = () => import('./Laundry/Delivery/new-order/new-order.module').then((x) => x.NeworderModule)
const printBillModule = () => import('./Laundry/Delivery/print-bill/printBill.module').then((x) => x.PrintBillModule)
const WorkInProgressModule = () => import('./Laundry/Delivery/work-in-progress/work-in-progress.module').then((x) => x.WorkInProgressModule)
const AssignAllModule = () => import('./Laundry/Delivery/assign-all/assign-all.module').then((x) => x.AssignAllModule)
const SecondPickupModule = () => import('./Laundry/Delivery/second-pickup/second-pickup.module').then((x) => x.SecondPickupModule)
const CashSettelmentModule = () => import('./Laundry/Delivery/cash-settelment/cash-settelment.module').then((x) => x.CashSettelmentModule)
// RoomOrder
const RoomServiceNewOModule = () => import('./RoomService/order/new-order/new-order.module').then((x) => x.RoomServiceNeworderModule)
const RoomServiceAccepetedModule = () => import('./RoomService/order/accepted/accepted.module').then((x) => x.RoomServiceAcceptedModule)
const RoomServiceDeliveryModule = () => import('./RoomService/order/delivery/delivery.module').then((x) => x.RoomServiceDeliveryModule)
const RoomServiceCancelModule = () => import('./RoomService/order/cancelled/cancelled.module').then((x) => x.RoomServiceCancelledModule)
const RoomServiceRejectModule = () => import('./RoomService/order/reject/reject.module').then((x) => x.RoomServiceRejectModule)
const RoomServicePrintBillModule = () => import('./RoomService/order/print-bill/print-bill.module').then((x) => x.RoomServicePrintBillModule)
const RoomServiceBilltodeskModule = () => import('./RoomService/order/billtodesk/billtodesk.module').then((x) => x.BilltodeskModule)
const RoomServicePickupModule = () => import('./RoomService/order/pickup/pickup.module').then((x) => x.RoomServicePickupModule)
const RoomServiceCashSettelmentModule = () => import('./RoomService/order/cash-settelment/cash-settelment.module').then((x) => x.CashSettelmentModule)

const LaundryStaffModule = () => import('./Laundry/laundry-staff-profile/laundry-staff-profile.module').then((x) => x.LaundryModule)
const ApartmentStaffModule = () => import('./apartment-staff-creation/apartment-staff-creation.module').then((x) => x.ApartmentStaffCreationModule)
const RestaurantStaffModule = () => import('./restaurant-staff-creation/restaurant-staff-creation.module').then((x) => x.RestaurantStaffCreationModule)


const FoodOutletTimingsModule = () => import('./Restaurant/food-outlet-timings/food-outlet-timings.module').then((x) => x.FoodOutletTimingsModule)
const LaundryOutletTimingsModule = () => import('./Laundry/laundry-outlet-timings/laundry-outlet-timings.module').then((x) => x.LaundryOutletTimingsModule)

// food order
const FoodNewsOrderModule = () => import('./Restaurant/order/food-new-order/food-new-order.module').then((x) => x.FoodNewOrderModule)
const FoodAcceptedModule = () => import('./Restaurant/order/food-order-accepted/food-order-accepted.module').then((x) => x.FoodOrderAcceptedModule)
const FoodCancelledModule = () => import('./Restaurant/order/food-order-cancelled/food-order-cancelled.module').then((x) => x.FoodOrderCancelledModule)
const FoodDeliveryModule = () => import('./Restaurant/order/food-order-delivery/food-order-delivery.module').then((x) => x.FoodOrderDeliveryModule)
const FoodPickupModule = () => import('./Restaurant/order/food-order-process-pickup/food-order-process-pickup.module').then((x) => x.FoodOrderProcessPickupModule)
const FoodRejectedModule = () => import('./Restaurant/order/food-order-rejected/food-order-rejected.module').then((x) => x.FoodOrderRejectedModule)
const FoodprintBillModule = () => import('./Restaurant/order/food-print-bill/food-print-bill.module').then((x) => x.FoodPrintBillModule)
const FoodPrintKotModule = () => import('./Restaurant/order/food-print-kot/food-print-kot.module').then((x) => x.FoodPrintKotModule)
const FoodCashSettelmentModule = () => import('./Restaurant/order/food-cash-settelment/food-cash-settelment.module').then((x) => x.FoodCashSettelmentModule)
const FoodOrderKanbanModule = () => import('./Restaurant/order/food-order-kanban/food-order-kanban.module').then((x) => x.FoodOrderKanbanModule)

// aditional order
const AditionalAcceptedModule = () => import('./RoomService/adititonal-order/aditional-accepted/aditional-accepted.module').then((x) => x.AditionalAcceptedModule)
const AditionalNewOrderModule = () => import('./RoomService/adititonal-order/aditional-new-order/aditional-new-order.module').then((x) => x.AditionalNewOrderModule)
const AditionalDeliveryModule = () => import('./RoomService/adititonal-order/aditional-delivered/aditional-delivered.module').then((x) => x.AditionalDeliveredModule)
const AditionalCancelledModule = () => import('./RoomService/adititonal-order/aditional-cancelled/aditional-cancelled.module').then((x) => x.AditionalCancelledModule)
const AditionalRejectedModule = () => import('./RoomService/adititonal-order/aditional-rejected/aditional-rejected.module').then((x) => x.AditionalRejectedModule)


// Notification
const LaundryNotificationModule = () => import('./Laundry/laundry-notification/laundry-notification.module').then((x) => x.LaundryNotificationModule)
const RestaurantNotificationModule = () => import('./Restaurant/restaurant-notification/restaurant-notification.module').then((x) => x.RestaurantNotificationModule)
const ApartmentNotificationModule = () => import('./RoomService/apartment-notification/apartment-notification.module').then((x) => x.ApartmentNotificationModule)
const CommunityNoticeModule = () => import('./RoomService/community-notice/community-notice.module').then((x) => x.CommunityNoticeModule)

const EmergencyNotification = () => import('./emergency-notification/emergency-notification.module').then(x => x.EmergencyNotificationModule)
const SavedAlertModule = () => import('./emergency-notification/saved-alert/saved-alert.module').then(x => x.SavedAlertModule)
const AlertResponseModule = () => import('./emergency-notification/alert-response/alert-response.module').then(x => x.AlertResponseModule)
const ActiveAlertModule = () => import('./emergency-notification/active-alert/active-alert.module').then(x => x.ActiveAlertModule)
const AlertHistroyModule = () => import('./emergency-notification/alert-history/alert-history.module').then(x => x.AlertHistoryModule)
const AlertReportModule = () => import('./emergency-notification/alert-report/alert-report.module').then(x => x.AlertReportModule)
const SosHistoryModule = () => import('./emergency-notification/sos-history/sos-history.module').then(x => x.SosHistoryModule)
const FloorMappingModule = () => import('./emergency-notification/floor-mapping/floor-mapping.module').then(x => x.FloorMappingModule)
const club = () => import('./club/club.module').then(x => x.ClubModule)
const spa = () => import('./spa/spa.module').then(x => x.SpaModule)
const AuditLogsComponent = () => import('./audit-logs/audit-logs.component').then(x => x.AuditLogsComponent)

const RestaurantCouponModule = () => import('./Restaurant/coupon/restaurant-coupon.module').then(x => x.RestaurantCouponModule)
const LaundryCouponModule = () => import('./Laundry/laundry-coupon/laundry-coupon.module').then(x => x.LaundryCouponModule)
const ApartmentCouponModule = () => import('./RoomService/apartment-coupon/apartment-coupon.module').then(x => x.ApartmentCouponModule)
const ClubCouponModule = () => import('./club/coupon/club-coupon.module').then(x => x.ClubCouponModule)
const ClubSpecialOffersModule = () => import('./club/special-offers/club-special-offers.module').then(x => x.ClubSpecialOffersModule)
const ApartmentPropertiesModule = () => import('./RoomService/properties/properties.module').then(x => x.PropertiesModule)
const ApartmentSettingsModule = () => import('./RoomService/apartment-settings/apartment-settings.module').then(x => x.ApartmentSettingsModule)
const RatingsModule = () => import('./RoomService/ratings/ratings.module').then(x => x.RatingsModule)
const ResidentialServiceModule = () => import('./ResidentialService/residential-service.module').then((x) => x.ResidentialServiceModule)

// Residential Service Order
const ResidentNewOrderModule = () => import('./ResidentialService/order/new-order/new-order.module').then((x) => x.RoomServiceNeworderModule)
const ResidentAcceptedModule = () => import('./ResidentialService/order/accepted/accepted.module').then((x) => x.RoomServiceAcceptedModule)
const ResidentTechnicianAssignedModule = () => import('./ResidentialService/order/technician-assigned/technician-assigned.module').then((x) => x.ResidentTechnicianAssignedModule)
const ResidentEstimationModule = () => import('./ResidentialService/order/estimation/estimation.module').then((x) => x.BilltodeskModule)
const ResidentInProgressModule = () => import('./ResidentialService/order/in-progress/inprogress.module').then((x) => x.RoomServicePickupModule)
const ResidentWorkInProgressModule = () => import('./ResidentialService/order/work-in-progress/work-in-progress.module').then((x) => x.ResidentWorkInProgressModule)
const ResidentRejectedModule = () => import('./ResidentialService/order/reject/reject.module').then((x) => x.RoomServiceRejectModule)
const ResidentCancelledModule = () => import('./ResidentialService/order/cancelled/cancelled.module').then((x) => x.RoomServiceCancelledModule)
const ResidentPrintBillModule = () => import('./ResidentialService/order/print-bill/print-bill.module').then((x) => x.RoomServicePrintBillModule)
const ResidentDeliveryModule = () => import('./ResidentialService/order/delivery/delivery.module').then((x) => x.RoomServiceDeliveryModule)
const GateVisitorComponent = () => import('./ResidentialService/gate-visitor/gate-visitor.component').then((x) => x.GateVisitorComponent)
const GateDeliveryComponent = () => import('./ResidentialService/gate-delivery/gate-delivery.component').then((x) => x.GateDeliveryComponent)
const GateHouseholdWorkerComponent = () => import('./ResidentialService/gate-household-worker/gate-household-worker.component').then((x) => x.GateHouseholdWorkerComponent)
const GateStaffLogsComponent = () => import('./ResidentialService/gate-staff-logs/gate-staff-logs.component').then((x) => x.GateStaffLogsComponent)
const DigitalLogsComponent = () => import('./ResidentialService/digital-logs/digital-logs.component').then((x) => x.DigitalLogsComponent)
const GateStaffAttendanceComponent = () => import('./ResidentialService/gate-staff-attendance/gate-staff-attendance.component').then((x) => x.GateStaffAttendanceComponent)
const VendorOnboardingRoutes = () => import('./vendor-onboarding/vendor-onboarding.routes').then((x) => x.VENDOR_ONBOARDING_ROUTES)
const NoAccessPageComponent = () => import('./_layouts/no-access/no-access-page.component').then((x) => x.NoAccessPageComponent)

const routes: Routes = [
  {
    path: 'no-access',
    loadComponent: NoAccessPageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    loadComponent: loginModule,
    canActivate: [LoginGuard]
  },
  {
    path: 'vendor-onboarding',
    loadChildren: VendorOnboardingRoutes
  },
  {
    path: 'reset-password/:jwtToken',
    loadComponent: restModule
  },
  {
    path: 'dashboard',
    loadComponent: dashboardModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'collective-dashboard',
    loadComponent: collectiveDashboardModule,
    canActivate: [AuthGuard]
  },

  {
    path: 'user',
    loadChildren: userModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'customer',
    loadChildren: customerModule,
    canActivate: [AuthGuard]
  },

  // Room service
  {
    path: 'room-service',
    loadChildren: RoomServiceModule,
    canActivate: [AuthGuard, RoomServiceGuard],
    data: { service: 'Room Service' }
  },
  {
    path: 'residential-service',
    loadChildren: ResidentialServiceModule,
    canActivate: [AuthGuard, RoomServiceGuard],
    data: { service: 'Residential Service' }
  },
  {
    path: 'facilities',
    loadComponent: () =>
      import('./facilities/facilities.component').then((x) => x.FacilitiesComponent),
    canActivate: [AuthGuard]
  },
  // laundry
  {
    path: 'laundry',
    loadChildren: LaundryModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'upload-laundry-banner',
    loadChildren: uploadLaundryBanner,
    canActivate: [AuthGuard]
  },
  // restaurant
  {
    path: 'restaurants',
    loadChildren: restaurantModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'upload-restaurant-banner',
    loadChildren: uploadRestaurantsBanner,
    canActivate: [AuthGuard]
  },
  // Menu Management
  {
    path: 'menu-management',
    loadChildren: MenuManagementModule,
    canActivate: [AuthGuard]
  },

  // Delivery
  {
    path: 'order-delivery',
    loadChildren: DeliveryModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'order-cancel',
    loadChildren: CancelModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'order-reject',
    loadChildren: rejectModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'order-accepted',
    loadChildren: AcceptedModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'new-order',
    loadChildren: NewOrderModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'order-pickup',
    loadChildren: PickupModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'print-bill',
    loadChildren: printBillModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'work-in-progress',
    loadChildren: WorkInProgressModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'assign-all',
    loadChildren: AssignAllModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'second-pickup',
    loadChildren: SecondPickupModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'cash-settlement',
    loadChildren: CashSettelmentModule,
    canActivate: [AuthGuard]
  },

  // Room Servoce Order
  {
    path: 'room-new-order',
    loadChildren: RoomServiceNewOModule,
    canActivate: [AuthGuard, RoomServiceGuard],
    data: { service: 'Room Order' }
  },
  {
    path: 'bill-to-desk',
    loadChildren: RoomServiceBilltodeskModule,
    canActivate: [AuthGuard, RoomServiceGuard],
    data: { service: 'Room Order' }
  },
  {
    path: 'room-accept-order',
    loadChildren: RoomServiceAccepetedModule,
    canActivate: [AuthGuard, RoomServiceGuard],
    data: { service: 'Room Order' }
  },
  {
    path: 'room-delivery-order',
    loadChildren: RoomServiceDeliveryModule,
    canActivate: [AuthGuard, RoomServiceGuard],
    data: { service: 'Room Order' }
  },
  {
    path: 'room-order-cancel',
    loadChildren: RoomServiceCancelModule,
    canActivate: [AuthGuard, RoomServiceGuard],
    data: { service: 'Room Order' }
  },
  {
    path: 'room-order-reject',
    loadChildren: RoomServiceRejectModule,
    canActivate: [AuthGuard, RoomServiceGuard],
    data: { service: 'Room Order' }
  },
  {
    path: 'room-print-bill',
    loadChildren: RoomServicePrintBillModule,
    canActivate: [AuthGuard, RoomServiceGuard],
    data: { service: 'Room Order' }
  },
  {
    path: 'pickup',
    loadChildren: RoomServicePickupModule,
    canActivate: [AuthGuard, RoomServiceGuard],
    data: { service: 'Room Order' }
  },
  {
    path: 'room-cash-settlement',
    loadChildren: RoomServiceCashSettelmentModule,
    canActivate: [AuthGuard, RoomServiceGuard],
    data: { service: 'Cash Settlement' }
  },

  // Food Order
  {
    path: 'food-order-kanban',
    loadChildren: FoodOrderKanbanModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'food-order-delivery',
    loadChildren: FoodDeliveryModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'food-order-cancel',
    loadChildren: FoodCancelledModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'food-order-reject',
    loadChildren: FoodRejectedModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'food-order-accepted',
    loadChildren: FoodAcceptedModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'food-new-order',
    loadChildren: FoodNewsOrderModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'food-order-pickup',
    loadChildren: FoodPickupModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'food-print-bill',
    loadChildren: FoodprintBillModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'food-print-kot',
    loadChildren: FoodPrintKotModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'food-cash-settlement',
    loadChildren: FoodCashSettelmentModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'food-outlet-timings',
    loadChildren: FoodOutletTimingsModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'laundry-outlet-timings',
    loadChildren: LaundryOutletTimingsModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'dashboard-laundry',
    loadComponent: () =>
      import('./laundry-dashboard/laundry-dashboard.component').then(m => m.LaundryDashboardComponent),
  },
  {
    path: 'restaurant-dashboard',
    loadComponent: () =>
      import('./restaurant-dashbaord/restaurant-dashbaord.component').then(m => m.RestaurantDashbaordComponent),
  },
  // staff
  {
    path: 'laundry-staff',
    loadChildren: LaundryStaffModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'apartment-staff',
    loadChildren: ApartmentStaffModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'restaurant-staff',
    loadChildren: RestaurantStaffModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'additional-new-order',
    loadChildren: AditionalNewOrderModule,
    canActivate: [AuthGuard, RoomServiceGuard],
    data: { service: 'Additional Orders' }
  },
  {
    path: 'additional-order-accepted',
    loadChildren: AditionalAcceptedModule,
    canActivate: [AuthGuard, RoomServiceGuard],
    data: { service: 'Additional Orders' }
  },
  {
    path: 'additional-order-delivery',
    loadChildren: AditionalDeliveryModule,
    canActivate: [AuthGuard, RoomServiceGuard],
    data: { service: 'Additional Orders' }
  },
  {
    path: 'additional-order-cancelled',
    loadChildren: AditionalCancelledModule,
    canActivate: [AuthGuard, RoomServiceGuard],
    data: { service: 'Additional Orders' }
  },
  {
    path: 'additional-order-rejected',
    loadChildren: AditionalRejectedModule,
    canActivate: [AuthGuard, RoomServiceGuard],
    data: { service: 'Additional Orders' }
  },
  {
    path: 'reports-laundry',
    loadChildren: LaundryReportGeneration,
    canActivate: [AuthGuard]
  },
  {
    path: 'reports-apartment',
    loadChildren: RoomReportGeneration,
    canActivate: [AuthGuard, RoomServiceGuard],
    data: { service: 'Reports' }
  },
  {
    path: 'reports-restaurant',
    loadChildren: restaurantReportGeneration,
    canActivate: [AuthGuard]
  },
  {
    path: 'reports-residential',
    loadChildren: ResidentialReportModule,
    canActivate: [AuthGuard, RoomServiceGuard],
    data: { service: 'Reports' }
  },
  {
    path: 'restaurant-settlement',
    loadChildren: RestaurantSettlementModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'laundry-settlement',
    loadChildren: LaundrySettlementModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'club-settlement',
    loadChildren: ClubSettlementModule,
    canActivate: [AuthGuard]
  },

  {
    path: 'laundry-notification',
    loadChildren: LaundryNotificationModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'restaurant-notification',
    loadChildren: RestaurantNotificationModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'apartment-notification',
    loadChildren: ApartmentNotificationModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'room-community-notice',
    loadChildren: CommunityNoticeModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'emergency-notification',
    loadChildren: EmergencyNotification,
    canActivate: [AuthGuard, EmergencyGuard],
    data: { service: 'Emergency' }
  },
  {
    path: 'active-alert',
    loadChildren: ActiveAlertModule,
    canActivate: [AuthGuard, EmergencyGuard],
    data: { service: 'Emergency' }
  },
  {
    path: 'alert-response',
    loadChildren: AlertResponseModule,
    canActivate: [AuthGuard, EmergencyGuard],
    data: { service: 'Emergency' }
  },
  {
    path: 'alert-history',
    loadChildren: AlertHistroyModule,
    canActivate: [AuthGuard, EmergencyGuard],
    data: { service: 'Emergency' }
  },
  {
    path: 'sos-history',
    loadChildren: SosHistoryModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'alert-report',
    loadChildren: AlertReportModule,
    canActivate: [AuthGuard, EmergencyGuard],
    data: { service: 'Emergency' }
  },
  {
    path: 'saved-alert',
    loadChildren: SavedAlertModule,
    canActivate: [AuthGuard, EmergencyGuard],
    data: { service: 'Emergency' }
  },
  {
    path: 'floor-mapping',
    loadChildren: FloorMappingModule,
    canActivate: [AuthGuard, EmergencyGuard],
    data: { service: 'Emergency' }
  },
  {
    path: 'club',
    loadChildren: club,
    canActivate: [AuthGuard]
  },
  {
    path: 'spa',
    loadChildren: spa,
    canActivate: [AuthGuard]
  },
  {
    path: 'audit-logs',
    loadComponent: AuditLogsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'restaurant-coupon',
    loadChildren: RestaurantCouponModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'laundry-coupon',
    loadChildren: LaundryCouponModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'apartment-coupon',
    loadChildren: ApartmentCouponModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'club-coupon',
    loadChildren: ClubCouponModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'club-special-offers',
    loadChildren: ClubSpecialOffersModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'apartment-properties',
    loadChildren: ApartmentPropertiesModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'apartment-settings',
    loadChildren: ApartmentSettingsModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'ratings',
    loadChildren: RatingsModule,
    canActivate: [AuthGuard],
    data: { service: 'Ratings' }
  },

  // Residential Service Order
  {
    path: 'resident-new-order',
    loadChildren: ResidentNewOrderModule,
    canActivate: [AuthGuard, RoomServiceGuard],
    data: { service: 'Residential Order' }
  },
  {
    path: 'resident-accepted',
    loadChildren: ResidentAcceptedModule,
    canActivate: [AuthGuard, RoomServiceGuard],
    data: { service: 'Residential Order' }
  },
  {
    path: 'resident-technician-assigned',
    loadChildren: ResidentTechnicianAssignedModule,
    canActivate: [AuthGuard, RoomServiceGuard],
    data: { service: 'Residential Order' }
  },
  {
    path: 'resident-estimation',
    loadChildren: ResidentEstimationModule,
    canActivate: [AuthGuard, RoomServiceGuard],
    data: { service: 'Residential Order' }
  },
  {
    path: 'resident-in-progress',
    loadChildren: ResidentInProgressModule,
    canActivate: [AuthGuard, RoomServiceGuard],
    data: { service: 'Residential Order' }
  },
  {
    path: 'resident-work-in-progress',
    loadChildren: ResidentWorkInProgressModule,
    canActivate: [AuthGuard, RoomServiceGuard],
    data: { service: 'Residential Order' }
  },
  {
    path: 'resident-rejected',
    loadChildren: ResidentRejectedModule,
    canActivate: [AuthGuard, RoomServiceGuard],
    data: { service: 'Residential Order' }
  },
  {
    path: 'resident-cancelled',
    loadChildren: ResidentCancelledModule,
    canActivate: [AuthGuard, RoomServiceGuard],
    data: { service: 'Residential Order' }
  },
  {
    path: 'resident-print-bill',
    loadChildren: ResidentPrintBillModule,
    canActivate: [AuthGuard, RoomServiceGuard],
    data: { service: 'Residential Order' }
  },
  {
    path: 'resident-delivery',
    loadChildren: ResidentDeliveryModule,
    canActivate: [AuthGuard, RoomServiceGuard],
    data: { service: 'Residential Order' }
  },
  {
    path: 'gate-visitor',
    loadComponent: GateVisitorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gate-delivery',
    loadComponent: GateDeliveryComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gate-household-worker',
    loadComponent: GateHouseholdWorkerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'digital-logs',
    loadComponent: DigitalLogsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gate-staff-logs',
    loadComponent: GateStaffLogsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gate-staff-attendance',
    loadComponent: GateStaffAttendanceComponent,
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    redirectTo: 'login'
  }



];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
